// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Axios from 'axios'
import VueI18n from 'vue-i18n'
import Croppa from 'vue-croppa'
import moment from 'moment'
import 'trumbowyg/dist/trumbowyg'
import 'trumbowyg/plugins/upload/trumbowyg.upload'
import 'trumbowyg/plugins/resizimg/trumbowyg.resizimg'
import 'trumbowyg/plugins/fontsize/trumbowyg.fontsize'
import 'trumbowyg/plugins/colors/trumbowyg.colors'

// Plugins CSS
import 'vue-croppa/dist/vue-croppa.css'
import 'trumbowyg/dist/ui/trumbowyg.css'

window.moment = moment
require('../static/js/plugin/datepicker/bootstrap-datetimepicker.min.js')

Vue.use(VueI18n)

window.fbAsyncInit = function () {
  window.FB.init({
    appId: '1328125167217203',
    xfbml: true,
    cookies: true,
    version: 'v2.7'
  })
}

Vue.use(Croppa)

Vue.prototype.$user = {}
Vue.prototype.$spotify = {
  token: ''
}
Vue.prototype.googleApiKey = 'AIzaSyBuuAXt1WKj2lGEI5Q5f33kYyjxhnlscPw'
Vue.prototype.$http = Axios
Vue.prototype.$http.defaults.withCredentials = true
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$notify = function (data, type, icon) {
  if (icon) {
    icon = 'fa ' + icon
  }

  window.$.notify({ title: data.title, message: data.message, icon: icon }, {
    type: type || 'default',
    placement: {
      from: 'top',
      align: 'center'
    },
    time: 1000,
    delay: 5000
  })
}

Vue.config.productionTip = false

if (localStorage.getItem('spotifyToken') && localStorage.getItem('tokenDate')) {
  let tokenDate = new Date(localStorage.getItem('tokenDate'))

  if (moment().diff(tokenDate, 'minutes') <= 60) { // 1 hour
    Vue.prototype.$spotify.token = localStorage.getItem('spotifyToken')
  } else {
    localStorage.removeItem('spotifyToken')
    localStorage.removeItem('accessToken')
  }
}

if (location.host.match(/localhost/)) {
  window.apiURL = 'http://localhost:3000/v1/'
} else if (location.host.match(/development/)) {
  window.apiURL = 'https://development.indiefy.net/v1/'
} else {
  window.apiURL = 'https://indiefy.net/v1/'
}

if (!window.gapi) {
  alert('Please disable any ad blocker')
}

window.gapi.load('client:auth2', () => {
  window.gapi.client.init({
    'clientId': '551586398920-cpk7un4cut3kgvo4ocusoqfjcpf8oeif.apps.googleusercontent.com',
    'discoveryDocs': ['https://www.googleapis.com/discovery/v1/apis/youtube/v3/rest'],
    'scope': 'https://www.googleapis.com/auth/youtube.force-ssl https://www.googleapis.com/auth/youtubepartner'
  }).then(() => {
    const GoogleAuth = window.gapi.auth2.getAuthInstance()
    Vue.prototype.GoogleAuth = GoogleAuth
  }, () => {
    if (window.gapi.auth2.getAuthInstance()) {
      Vue.prototype.GoogleAuth = window.gapi.auth2.getAuthInstance()
    }
  })
})

let lang = window.navigator.language.split('_')[0]

if (window.location.search.includes('lang=')) {
  lang = window.location.search.split('lang=')[1]
}

if (!['en', 'es'].includes(lang)) {
  lang = 'en'
}

const i18n = Vue.prototype.i18n = new VueI18n({
  locale: lang,
  fallbackLocale: 'en'
})

import(`../static/langs/${lang}.json`).then(msgs => {
  i18n.setLocaleMessage(lang, msgs)
  i18n.locale = lang

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js